import * as globals from '@wandb/common/css/globals.styles';
import React, {FC, memo} from 'react';
import styled from 'styled-components';

import {useBetaFeatureNightModeEnabled} from '../../util/useBetaFeature';
import {NightAwareProps} from '.';

type EmptyStateProps = {
  header?: string;
  body?: string;
};

const EmptyStateComp: FC<EmptyStateProps> = ({header, body}) => {
  const isNightMode = useBetaFeatureNightModeEnabled();

  if (!header && !body) {
    return null;
  }

  return (
    <EmptyStateContainer>
      <EmptyStateText isNightMode={isNightMode}>
        {header && <EmptyStateHeader>{header}</EmptyStateHeader>}
        {body && <EmptyStateBody>{body}</EmptyStateBody>}
      </EmptyStateText>
    </EmptyStateContainer>
  );
};

export const EmptyState = memo(EmptyStateComp);

const EmptyStateContainer = styled.div`
  padding: 24px;
  margin-top: 16px;
  background-color: ${globals.GRAY_25};
  border-radius: 4px;
  text-align: center;
`;

const EmptyStateText = styled.div<NightAwareProps>`
  color: ${p => (!p.isNightMode ? globals.GRAY_500 : globals.GRAY_600)};
`;

const EmptyStateHeader = styled.div`
  font-weight: 600;
`;

const EmptyStateBody = styled.div`
  margin-top: 8px;
`;
